export const generarHtmlCorreo = ({
    titulo = "Notificación",
    encabezado = "Mensaje Importante",
    logoCid = "iconHtml",
    cuerpo = "",
    colorHeader = "#b8ffc3",
    background = "#f4f4f7",
    botonTexto = "",
    botonLink = ""
}) => {
    return `<!DOCTYPE html>
    <html lang="es">
    <head>
      <title>${titulo}</title>
      <meta charset="UTF-8">
      <style>
        body {
          font-family: Arial, sans-serif;
          margin: 0;
          padding: 0;
          background-color: ${background};
        }
        /* Contenedor externo para fondo visible */
        .outer-table {
          width: 100%;
          background-color: ${background};
        }
        .outer-td {
          padding: 40px 0;
          text-align: center;
        }
        /* Contenedor interno principal */
        .container {
          background-color: #ffffff;
          max-width: 600px;
          margin: 0 auto;
          border-radius: 8px;
          box-shadow: 0 0 10px rgba(0,0,0,0.1);
          overflow: hidden;
        }
        .header {
          background-color: ${colorHeader};
          text-align: center;
          padding: 20px;
        }
        .header img {
          max-width: 80px;
          height: auto;
          margin-bottom: 10px;
        }
        .header h2 {
          margin: 0;
          font-size: 22px;
        }
        .content {
          padding: 20px;
          font-size: 16px;
          color: #333;
          line-height: 1.5;
        }
        .button-container {
          text-align: center;
          margin-top: 30px;
        }
        .button-container a {
          display: inline-block;
          padding: 12px 25px;
          background-color: ${colorHeader};
          color: #fff;
          text-decoration: none;
          border-radius: 5px;
          font-weight: bold;
          transition: background-color 0.3s;
        }
        .button-container a:hover {
          background-color: darkgreen;
        }
      </style>
    </head>
    <body>
      <table class="outer-table" cellpadding="0" cellspacing="0" border="0">
        <tr>
          <td class="outer-td">
            <table class="container" cellpadding="0" cellspacing="0" border="0">
              <tr>
                <td class="header">
                  <img src="cid:${logoCid}" alt="Logo">
                  <h2>${encabezado}</h2>
                </td>
              </tr>
              <tr>
                <td class="content">
                  ${cuerpo}
                  ${botonTexto && botonLink ? `
                  <div class="button-container">
                    <a href="${botonLink}">${botonTexto}</a>
                  </div>` : ""}
                </td>
              </tr>
            </table>
          </td>
        </tr>
      </table>
    </body>
    </html>`;
};
